module.exports = __webpack_public_path__ + "img/thumb_28.0d7face0.jpg";